import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { ManagedToursState } from './managed-tour.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([ManagedToursState])],
  declarations: []
})
export class ManagedTourStoreModule {}
